import { useState } from 'react'

import imageToBase64 from 'helpers/imageToBase64'

import ApplyFormLabel from '../ApplyFormLabel'
import FileDropzone from 'components/FileDropzone'
import ApplyStepIcon from 'components/ApplyStepIcon'
import ApplyStepButtons from 'components/ApplyStepButtons'

import s from './ApplyFormGuardianConsent.module.css'
import isModellinkSite from '../../../helpers/isModellinkSite'
import * as Sentry from '@sentry/nextjs'

//TODO: setup proptypes
function ApplyFormGuardianConsent({ onSubmit, goBack, initialValues }) {
  const [errors, setErrors] = useState([])
  const [fieldValues, setFieldValues] = useState({
    guardianFirstName: initialValues.guardianFirstName || '',
    guardianSurname: initialValues.guardianSurname || '',
    guardianEmail: initialValues.guardianEmail || '',
    guardianPhoto: initialValues.guardianPhoto || null,
    guardianConsent: initialValues.guardianConsent || null,
  })

  const handleAttrChange = (attr, val) => {
    const fields = { ...fieldValues }
    fields[attr] = val
    setFieldValues(fields)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    const newErrors = Object.keys(fieldValues).filter((f) => !fieldValues[f])
    if (newErrors.length) {
      setErrors(newErrors)
    } else {

      const submitValues = {...fieldValues}

      Sentry.addBreadcrumb({
        category: 'form',
        message: 'Guardian Consent Details Submitted',
        level: 'debug',
        data: submitValues,
      })

      onSubmit(submitValues)
    }
  }

  const handleFileSelect = (attr, acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      const fields = { ...fieldValues }
      fields[attr] = {
        name: acceptedFiles[0].file.name,
        preview: acceptedFiles[0].preview,
        data: null,
        loading: true,
      }
      setFieldValues(fields)
      imageToBase64(acceptedFiles[0].file, {
        maxHeight: 1000,
        maxWidth: 1000,
      }).then((resp) => {
        setFieldValues((curState) => {
          const curFields = { ...curState }
          curFields[attr].data = resp.base64
          curFields[attr].loading = false
          return { ...curFields }
        })
      })
    }
  }

  const businessName = isModellinkSite() ? 'Modellink' : 'Select Models'

  return (
    <div className={s.container}>
      <form onSubmit={handleSubmit}>
        <h1 className={s.title}>Guardian Consent</h1>
        <p className={s.text}>
          As you are under the age of 16 we require consent of your parent or
          guardian.
          <br />
          <br />
          We request they fill out the remainder of this application.
        </p>
        <div className={s.field}>
          <ApplyFormLabel
            errors={errors}
            attrs={[
              { attr: 'guardianFirstName', label: 'First name' },
              { attr: 'guardianSurname', label: 'Surname' },
            ]}
            label='Guardian Name'
          />
          <input
            type='text'
            placeholder='First name'
            id='guardianFirstName'
            name='guardianFirstName'
            className={s.input}
            value={fieldValues.guardianFirstName}
            onChange={(e) =>
              handleAttrChange('guardianFirstName', e.target.value)
            }
          />
          <input
            type='text'
            placeholder='Surname'
            name='guardianSurname'
            className={s.input}
            value={fieldValues.guardianSurname}
            onChange={(e) =>
              handleAttrChange('guardianSurname', e.target.value)
            }
          />
        </div>
        <div className={s.field}>
          <ApplyFormLabel
            errors={errors}
            attr={{ attr: 'guardianPhoto', label: 'Photo I.D' }}
            label='Photo I.D'
          />
          <FileDropzone
            disabled={
              fieldValues.guardianPhoto && fieldValues.guardianPhoto.loading
            }
            onDrop={(files) => handleFileSelect('guardianPhoto', files)}
            file={fieldValues.guardianPhoto}
          />
        </div>
        <div className={s.field}>
          <ApplyFormLabel
            errors={errors}
            attr={{ attr: 'guardianEmail', label: 'Email' }}
            label='Email'
          />
          <input
            type='email'
            placeholder='name@domain.com'
            id='guardianEmail'
            name='guardianEmail'
            value={fieldValues.guardianEmail}
            className={s.input}
            onChange={(e) => handleAttrChange('guardianEmail', e.target.value)}
          />
        </div>
        <p className={s.consentText}>
          I give consent to {businessName} to process the data to evaluate the
          potential of a minor in my care in becoming a model, and agree for a
          member from {businessName} to contact both myself and the minor if
          successful. Your application will be stored for upto 90 days.
        </p>
        <div className={s.field}>
          {errors && errors.includes('guardianConsent') && (
            <p className={s.checkboxError}>
              Consent must be granted to continue
            </p>
          )}
          <label className={s.checkboxLabel} htmlFor='guardianConsent'>
            <input
              type='checkbox'
              id='guardianConsent'
              name='guardianConsent'
              onChange={(e) =>
                handleAttrChange('guardianConsent', e.target.checked)
              }
              checked={fieldValues.guardianConsent}
              className={s.checkbox}
            />
            <span className={s.checkboxIcon} />
            Consent Granted
          </label>
        </div>
        <ApplyStepButtons back={goBack} />
      </form>
      <ApplyStepIcon step='guardian' />
    </div>
  )
}

export default ApplyFormGuardianConsent
